import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider, CartProvider } from "./lib/store";
import { Toaster } from "sonner";

import Header from "./components/Header";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import WhatsappFab from "./components/WhatsappFab";

import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import ProductDetail from "./pages/ProductDetail";
import Checkout from "./pages/Checkout";
import { CheckoutSuccess, CheckoutPending, CheckoutFailure } from "./pages/CheckoutResult";
import Appointments from "./pages/Appointments";
import Login from "./pages/Login";
import CustomerAccount from "./pages/CustomerAccount";
import Admin from "./pages/Admin";
import AuthCallback from "./pages/AuthCallback";
import About from "./pages/About";
import Contact from "./pages/Contact";
import ErrorBoundary from "./components/ErrorBoundary";

function Layout({ children }) {
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith("/admin");
  const isCallback = loc.pathname === "/auth/callback";
  if (isAdmin || isCallback) return children;
  return (
    <>
      <Header />
      <main className="min-h-[70vh]">{children}</main>
      <Footer />
      <CartDrawer />
      <WhatsappFab />
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <ErrorBoundary>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/catalogo" element={<Catalog />} />
              <Route path="/produto/:slug" element={<ProductDetail />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/checkout/sucesso" element={<CheckoutSuccess />} />
              <Route path="/checkout/pendente" element={<CheckoutPending />} />
              <Route path="/checkout/falha" element={<CheckoutFailure />} />
              <Route path="/agendar" element={<Appointments />} />
              <Route path="/entrar" element={<Login />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/minha-conta" element={<CustomerAccount />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/sobre" element={<About />} />
              <Route path="/contato" element={<Contact />} />
            </Routes>
          </Layout>
          </ErrorBoundary>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}
